<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, { 'no-scroll': isAppPage }]">

    <vx-tour :steps="steps"
      v-if="!disableThemeTour && (windowWidth >= 1200 && mainLayoutType === 'vertical' && verticalNavMenuWidth == 'default')" />

    <the-customizer v-if="!disableCustomizer" :footerType="footerType" :hideScrollToTop="hideScrollToTop"
      :navbarType="navbarType" :navbarColor="navbarColor" :routerTransition="routerTransition"
      @toggleHideScrollToTop="toggleHideScrollToTop" @updateFooter="updateFooter" @updateNavbar="updateNavbar"
      @updateNavbarColor="updateNavbarColor" @updateRouterTransition="updateRouterTransition" />

    <!-- :navMenuItems = "navMenuItems" -->

    <v-nav-menu :navMenuItems="$store.state.auth.menu" title="Vuexy" parent=".layout--main" />

    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay" />

      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal :navbarType="$store.state.auth.menu" :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark }
        ]" />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark }
        ]" :navMenuItems="mainMenu" />
      </template>

      <template v-else>
        <the-navbar-vertical :navbarColor="navbarColor" :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark }
        ]" />
      </template>
      <!-- /Navbar -->

      <vs-popup class="module-updates" title="Atualizações do Módulo" :active.sync="showModuleUpdatesModal">
        <div class="vx-row">
          <div class="vx-col w-full">
            <!-- <vs-input class="w-full mt-4" label="Nova Senha" v-model="newPassword" name="newPassword" type="password" /> -->
            <vs-checkbox class="mb-3" v-model="selectAllFields">Selecionar todos</vs-checkbox>
            <label class="vs-input--label">Selecione os campos:</label>
            <div @click="onSelectClick">
              <v-select multiple :closeOnSelect="true" v-model="fieldsSelected" label="name" :options="fieldOptions"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>
        </div>
        <br>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div id="blank_content" style="height: 1px;" v-show="showBlankContent"></div>
            <!-- <vx-card> -->
            <template v-if="timeLineData.length > 0">
              <vx-timeline :data="timeLineData" />
            </template>
            <div v-else-if="fieldsSelectedToFilter.length > 0" class="not-data-table vs-table--not-data">Sem histórico
              de
              atualizações</div>
            <vs-pagination v-if="timeLineData.length > 0" :total="totalPages" v-model="paginationIndex"></vs-pagination>
            <!-- </vx-card> -->
          </div>
        </div>
      </vs-popup>

      <vs-popup class="add-dashboard-card" title="Adicionar Card"
        :active.sync="dashboardData.showAddDashboardCardModal">
        <div class="vx-row">
          <div class="vx-col w-full">
            <label class="vs-input--label">Tipo do card:</label>
            <v-select :closeOnSelect="true" label="name" v-model="dashboardData.cardType"
              :options="dashboardData.cardTypeOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input class="w-full mt-4 mb-4" label="Nome" v-model="dashboardData.cardName" name="card-name" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <label for="card-description" class="vs-input--label mt-4">Descrição</label>
            <vs-textarea class="w-full" v-model="dashboardData.cardDescription" name="card-description" />
          </div>
        </div>
        <br><br><br><br>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <vs-button class="ml-auto mt-2" @click="addDashboardCard">Salvar</vs-button>
          </div>
        </div>
      </vs-popup>

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

              <!-- DROPDOWN -->
              <!-- <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer" v-if="$route.name === 'modules-view'">
                  <vs-button radius icon="icon-settings" icon-pack="feather" />

                  <vs-dropdown-menu class="w-50">
                    <vs-dropdown-item>
                      <div @click="showModuleUpdatesModal = true" class="flex items-center">
                        <feather-icon icon="RefreshCwIcon" class="inline-block mr-2 mt-1" svgClasses="w-4 h-4" />
                        <span>Atualizações</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>

                </vs-dropdown> -->


              <!-- <vs-dropdown-item>
                      <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
                        <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Tasks</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">
                        <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Inbox</span>
                      </div>
                    </vs-dropdown-item> -->

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center mb-6">
                <div class="content-area__heading"
                  :class="{ 'pr-4 border-0 md:border-r border-solid border-grey-light': $route.meta.breadcrumb }">
                  <h2 class="mb-1">{{ `${routeTitle}` }}</h2>
                </div>
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route"
                  :breadcrumb="routeBreadcrumb" :isRTL="$vs.rtl" />
              </div>
              <div v-else-if="$store.state.auth.user.is_admin || false"
                class="router-header flex flex-wrap items-center mb-6"
                style="margin-top: -15px!important;padding: 2em;margin: -2em;">
                <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer"
                  v-if="$route.name === 'dashboard'">
                  <vs-button radius icon="icon-settings" icon-pack="feather"
                    style="z-index: 202020200202020202020202!important;" />
                  <vs-dropdown-menu class="w-50">
                    <vs-dropdown-item style="width: 190px!important;" v-show="showViewModeOption">
                      <div @click="setViewMode" class="flex items-center">
                        <feather-icon icon="EyeIcon" class="inline-block mr-2 mt-1" svgClasses="w-4 h-4" />
                        <span>Modo de Visualização</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item style="width: 190px!important;" v-show="showEditModeOption">
                      <div @click="setEditMode" class="flex items-center">
                        <feather-icon icon="Edit3Icon" class="inline-block mr-2 mt-1" svgClasses="w-4 h-4" />
                        <span>Modo de Edição</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item style="width: 190px!important;" v-show="!showEditModeOption">
                      <div @click="updateDashboardLayout" class="flex items-center">
                        <feather-icon icon="SaveIcon" class="inline-block mr-2 mt-1" svgClasses="w-4 h-4" />
                        <span>Salvar Layout</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item style="width: 190px!important;" v-show="!showEditModeOption">
                      <div @click="dashboardData.showAddDashboardCardModal = true" class="flex items-center">
                        <feather-icon icon="PlusIcon" class="inline-block mr-2 mt-1" svgClasses="w-4 h-4" />
                        <span>Adicionar Card</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500"
                v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>


<script>
import BackToTop from 'vue-backtotop'
import HNavMenu from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
import navMenuItems from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import TheCustomizer from '@/layouts/components/customizer/TheCustomizer.vue'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'
import themeConfig from '@/../themeConfig.js'
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import VxTimeline from '@/components/timeline/VxTimeline'
import vSelect from 'vue-select'
import { performFetch } from '../../helpers.js'

const VxTour = () => import('@/components/VxTour.vue')

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheCustomizer,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    vSelect,
    VxTour,
    VxTimeline
  },
  data() {
    return {
      showViewModeOption: false,
      showEditModeOption: true,
      selectAllFields: false,
      showBlankContent: false,
      dashboardData: {
        showAddDashboardCardModal: false,
        cardType: {},
        cardTypeOptions: [],
        cardName: '',
        cardDescription: ''
      },
      dashboardDataEdit: {
        cardHash: '',
        cardName: '',
        cardType: {},
        cardDescription: '',
        showEditDashboardCardModal: false
      },
      paginationIndex: 1,
      totalPages: 1,
      timeLineData: [],
      showModuleUpdatesModal: false,
      fieldOptions: [],
      fieldsSelected: [],
      fieldsSelectedToFilter: [],
      mainMenu: this.$store.state.auth.menu,
      disableCustomizer: themeConfig.disableCustomizer,
      disableThemeTour: themeConfig.disableThemeTour,
      dynamicWatchers: {},
      footerType: themeConfig.footerType || 'static',
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || '#fff',
      navbarType: themeConfig.navbarType || 'floating',
      navMenuItems,
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle: this.$route.meta.pageTitle,
      routeBreadcrumb: this.$route.meta.breadcrumb,
      steps: [
        {
          target: '#btnVNavMenuMinToggler',
          content: 'Toggle Collapse Sidebar.'
        },
        {
          target: '.vx-navbar__starred-pages',
          content: 'Create your own bookmarks. You can also re-arrange them using drag & drop.'
        },
        {
          target: '.i18n-locale',
          content: 'You can change language from here.'
        },
        {
          target: '.navbar-fuzzy-search',
          content: 'Try fuzzy search to visit pages in flash.'
        },
        {
          target: '.customizer-btn',
          content: 'Customize template based on your preference',
          params: {
            placement: 'left'
          }
        },
        {
          target: '.vs-button.buy-now',
          content: 'Buy this awesomeness at affordable price!',
          params: {
            placement: 'top'
          }
        }
      ]
    }
  },
  watch: {
    selectAllFields(newValue) {
      if (newValue) {
        this.fieldsSelected = this.fieldOptions
      } else {
        this.fieldsSelected = []
      }
    },
    paginationIndex(newValue, oldValue) {
      this.getModuleFieldUpdates()
    },
    fieldsSelected(val) {

      if (val.length > 0) {
        this.showBlankContent = false

        this.paginationIndex = 1

        if (val.length > 0) {

          this.fieldsSelectedToFilter = []

          val.forEach((fieldItem) => {
            this.fieldsSelectedToFilter.push(fieldItem.hash)
          })

          this.getModuleFieldUpdates()
        }
      } else {
        this.timeLineData = []
      }
    },
    async showModuleUpdatesModal(val) {
      if (val) {

        // await fetch(`${this.$store.state.auth.api_url}`, {
        //   method: 'POST', headers: {"Content-Type": "application/json"},
        //   body: JSON.stringify({
        //     command: 'module_management_get_application_module_fields',
        //     parameters: {
        //       application_token: this.$store.state.auth.app_token,
        //       session_token: this.$store.state.auth.token,
        //       module_token: this.$route.params.moduleHash
        //     }
        //   })
        // })
        await performFetch(`${this.$store.state.auth.api_url}`, {
          command: 'module_management_get_application_module_fields',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: this.$route.params.moduleHash
          }
        })
          .then(async (response) => {
            this.$vs.loading.close()
            if (response.status === 200) {

              response.json().then(responseData => {

                const moduleFieldList = []

                responseData.module.payload.forEach((item) => {
                  item.fields.forEach((fieldItem) => {
                    if (!fieldItem.core) {
                      const fieldObject = {
                        hash: fieldItem.hash,
                        name: fieldItem.title
                      }

                      moduleFieldList.push(fieldObject)
                      // this.fieldsSelectedToFilter.push(fieldObject.hash)
                    }
                  })
                })

                moduleFieldList.sort((a, b) => {
                  if (a.name < b.name) { return -1; }
                  if (a.name > b.name) { return 1; }
                  return 0;
                })

                this.fieldOptions = moduleFieldList

                this.fieldsSelected = []

                this.$vs.loading.close()
              })

            } else if (response.status == 401) {
              setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
              this.$store.dispatch('auth/signOut')
            } else {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Operação não realizada!',
                text: 'Ocorreu um erro ao buscar os campos do módulo!',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'danger'
              })
            }
          })
          .catch((e) => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
            throw new Error(e.message)
          })
      } else {
        this.selectAllFields = false
      }
    },
    '$store.state.auth.menu'(val) {
      this.mainMenu = val
    },
    '$store.state.auth.currentModuleName'() {
      this.updateModuleNameInBreadcrumb()
    },
    '$store.state.auth.currentModuleNameEn'() {
      this.updateModuleNameInBreadcrumb()
    },
    '$i18n.locale'() {
      this.updateModuleNameInBreadcrumb()
    },
    '$route'() {
      setTimeout(() => {
        if (!this.$route.meta.hasOwnProperty('customModuleRoute')) {
          this.routeTitle = this.$route.meta.pageTitle
          this.routeBreadcrumb = this.$route.meta.breadcrumb
        }
      }, 300)
    },
    '$store.state.auth'(val) {
      // this.mainMenu = val
    },
    isThemeDark(val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType'(val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    },
    async 'dashboardData.showAddDashboardCardModal'(val) {
      if (!val) {
        this.clearAddCardForm()
      } else {
        if (this.dashboardData.cardTypeOptions.length === 0) {
          await this.getDashboardParameters()
        }
      }
    }
  },
  computed: {
    auth() {
      return this.$store.state.auth
    },
    menu() {
      return this.$store.state.auth.menu
    },
    bodyOverlay() { return this.$store.state.bodyOverlay },
    contentAreaClass() {
      if (this.mainLayoutType === 'vertical') {
        if (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage() {
      return this.$route.meta.no_scroll
    },
    isThemeDark() { return this.$store.state.theme === 'dark' },
    layoutTypeClass() { return `main-${this.mainLayoutType}` },
    mainLayoutType() { return this.$store.state.mainLayoutType },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType === 'hidden',
        'navbar-sticky': this.navbarType === 'sticky',
        'navbar-static': this.navbarType === 'static',
        'navbar-floating': this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth },
    windowWidth() { return this.$store.state.windowWidth }
  },
  methods: {
    setViewMode() {
      this.$store.commit('dashboardAnalytics/SET_VIEW_MODE', 'view')
      this.showEditModeOption = true
      this.showViewModeOption = false
    },
    setEditMode() {
      this.$store.commit('dashboardAnalytics/SET_VIEW_MODE', 'edit')
      this.showEditModeOption = false
      this.showViewModeOption = true
    },
    updateModuleNameInBreadcrumb() {
      setTimeout(() => {
        const moduleName = this.$store.state.auth.currentModuleName
        if (moduleName !== null && moduleName !== undefined && this.$route.meta.hasOwnProperty('customModuleRoute')) {
          const moduleNameEn = this.$store.state.auth.currentModuleNameEn
          const displayName = this.$i18n.locale === 'en' && moduleNameEn ? moduleNameEn : moduleName
          this.routeTitle = displayName
          const tempBreadcrumb = JSON.parse(JSON.stringify(this.$route.meta.breadcrumb))
          tempBreadcrumb[1]['title'] = displayName
          tempBreadcrumb[1]['url'] = '/modules/' + this.$route.params.moduleHash
          this.routeBreadcrumb = tempBreadcrumb
        }
      }, 300)
    },
    onSelectClick() {

      if (!this.showBlankContent) {

        try {
          const offsetHeight = document.querySelector('.vs__dropdown-menu').offsetHeight

          document.querySelector('#blank_content').style.height = offsetHeight + 'px'

          this.showBlankContent = true
        } catch (e) {
          //
        }
      }
    },
    async getCardDetail(cardHash) {
      this.$vs.loading({ type: 'default' })

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_dashboard_card_detail',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       card_hash: cardHash
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'get_application_dashboard_card_detail',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          card_hash: cardHash
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(responseData => {

              this.dashboardDataEdit.cardName = responseData.card.name
              this.dashboardDataEdit.cardDescription = responseData.card.description
              this.dashboardDataEdit.cardType = this.dashboardData.cardTypeOptions.find(x => x.hash === responseData.card.type.hash)

              this.dashboardDataEdit.showEditDashboardCardModal = true
              this.$vs.loading.close()
            })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Atenção!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    validateAddCardForm() {
      if (this.dashboardData.cardName === '' || this.dashboardData.cardName === null) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo Nome é obrigatório!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (JSON.stringify(this.dashboardData.cardType) === '{}' || !this.dashboardData.cardType.hasOwnProperty('id')) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo Tipo do Card é obrigatório!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return true

    },
    async addDashboardCard() {

      await this.updateDashboardLayout()

      if (!this.validateAddCardForm()) {
        return
      }

      this.$vs.loading({ type: 'default' })

      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'add_application_dashboard_card',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          card: {
            dashboard_hash: this.$route.params.dashboardHash,
            name: this.dashboardData.cardName,
            description: this.dashboardData.cardDescription,
            type_id: this.dashboardData.cardType.id
          }
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            this.dashboardData.showAddDashboardCardModal = false

            this.clearAddCardForm()

            this.$store.commit('dashboardAnalytics/SET_MAIN_DIV_KEY')

            this.$store.commit('dashboardAnalytics/SET_NEED_RELOAD', true)

            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação realizada!',
              text: 'Card adicionado com sucesso!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Atenção!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    clearAddCardForm() {
      this.dashboardData.cardName = ''
      this.dashboardData.cardDescription = ''
      this.dashboardData.cardType = {}
    },
    async getDashboardParameters() {
      this.$vs.loading({ type: 'default' })
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //     method: 'POST', headers: {"Content-Type": "application/json"},
      //     headers: {"Content-Type": "application/json"},
      //     body: JSON.stringify({
      //       command: 'get_application_dashboard_management_parameters',
      //       parameters: {
      //         application_token: this.$store.state.auth.app_token,
      //         session_token: this.$store.state.auth.token
      //       }
      //     })
      //   })
      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'get_application_dashboard_management_parameters',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(responseData => {

              responseData.parameters.cards.forEach(item => {
                const cardObject = {
                  id: item.id,
                  name: item.name
                }

                this.dashboardData.cardTypeOptions.push(cardObject)
              })

              this.$vs.loading.close()
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()

            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao carregar os parâmetros da tela',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async updateDashboardLayout() {
      this.$vs.loading({ type: 'default' })

      await this.$store.dispatch('dashboardAnalytics/updateDashboardLayout', {
        hash: this.$route.params.dashboardHash,
        data: this.$store.state.dashboardAnalytics.cardsData,
        screen_size: this.$store.state.dashboardAnalytics.screenSize
      })
        .then(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação Realizada!',
            text: `Layout atualizado com sucesso!`,
            iconPack: 'feather',
            icon: 'icon-success-circle',
            color: 'success'
          })
        })
    },
    async getModuleFieldUpdates() {

      this.$vs.loading({ type: 'default' })

      const iconsDict = {
        1: 'Edit2Icon',
        2: 'Edit2Icon',
        3: 'PhoneIcon',
        4: 'MailIcon',
        5: 'InstagramIcon',
        6: 'FacebookIcon',
        7: 'LinkedinIcon',
        8: 'Link2Icon',
        9: 'TwitterIcon',
        10: 'PhoneIcon',
        11: 'YoutubeIcon',
        12: 'CalendarIcon',
        13: 'ClockIcon',
        14: 'PhoneIcon',
        15: 'SlackIcon',
        16: 'PercentIcon',
        17: 'ClockIcon',
        18: 'DollarSignIcon',
        19: 'Edit2Icon',
        20: 'Edit2Icon',
        21: 'Edit2Icon',
        22: 'FileIcon',
        23: 'FileIcon',
        24: 'ListIcon',
        25: 'ListIcon',
        26: 'ListIcon',
        27: 'MapPinIcon',
        28: 'PaperclipIcon',
        29: 'TagIcon',
        30: 'ListIcon'
      }

      this.timeLineData = []

      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'get_module_field_updates',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          row_hash: this.$route.params.rowHash,
          fields: this.fieldsSelectedToFilter,
          page: this.paginationIndex,
          per_page: 5
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {
              const timeLineData = []

              const colors = ['primary', 'success', 'warning', 'danger']

              let colorIndex = 0

              this.totalPages = response.payload.pagination.pages

              response.payload.updates.forEach((value, key) => {

                let from = value.old_value

                let to = value.new_value

                if (value.field_type_id === 16 || value.field_type_id === 18 || value.field_type_id === 20) {

                  let config = null

                  if (value.field_type_id === 16 || value.field_type_id === 20) {
                    config = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                  } else {
                    config = { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }
                  }

                  const parseValue = parseFloat(from)
                  const parseValueTo = parseFloat(to)

                  if (!isNaN(parseValue)) {
                    from = parseFloat(from).toLocaleString('pt-BR', config)

                    if (value.field_type_id === 16) {
                      from = from + '%'
                    }
                  } else {
                    from = null
                  }

                  if (!isNaN(parseValueTo)) {
                    to = parseFloat(to).toLocaleString('pt-BR', config)

                    if (value.field_type_id === 16) {
                      to = to + '%'
                    }
                  } else {
                    to = null
                  }

                }
                // else if (objectValue.mask) {
                //   const formatter = new StringMask(objectValue.mask)
                //   const result = formatter.apply(objectValue.payload)

                //   objectValue = result
                // }
                else {
                  from = from
                  to = to
                }

                const isDateTime = this.checkIfStringIsDateTime(from)
                const isDateTimeTo = this.checkIfStringIsDateTime(to)

                if (isDateTime) {

                  const date = from.split(' ')[0].trim()
                  const time = from.split(' ')[1].trim()

                  from = `${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]} ${time}`

                }

                if (isDateTimeTo) {

                  const dateTo = to.split(' ')[0].trim()
                  const timeTo = to.split(' ')[1].trim()

                  to = `${dateTo.split('-')[2]}/${dateTo.split('-')[1]}/${dateTo.split('-')[0]} ${timeTo}`

                }


                const isDate = this.checkIfStringIsDate(from)
                const isDateTo = this.checkIfStringIsDate(to)

                if (isDate) {

                  from = `${from.split('-')[2]}/${from.split('-')[1]}/${from.split('-')[0]}`
                }

                if (isDateTo) {

                  to = `${to.split('-')[2]}/${to.split('-')[1]}/${to.split('-')[0]}`
                }

                if (to === null) {
                  to = 'Vazio'
                }

                if (from === null) {
                  from = 'Vazio'
                }

                const object = {
                  index: key,
                  color: colors[colorIndex],
                  icon: iconsDict[value.field_type_id],
                  title: `Campo: ${value.field_title}`,
                  desc_one: `De: ${from}`,
                  desc_two: `Para: ${to}`,
                  time: `${value.updated_at.split(' ')[0].split('-')[2]}/${value.updated_at.split(' ')[0].split('-')[1]}/${value.updated_at.split(' ')[0].split('-')[0]} ${value.updated_at.split(' ')[1]}`,
                  user: `Atualizado Por: ${value.user}`
                }

                timeLineData.push(object)

                if (colorIndex >= 3) {
                  colorIndex = 0
                } else {
                  colorIndex++
                }
              })

              this.timeLineData = timeLineData

              this.$vs.loading.close()
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()

            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao carregar as atualizações do módulo',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    checkIfStringIsDateTime(string) {

      try {
        if ((string.split('-').length - 1) == 2 && (string.split(':').length - 1) == 2 && (string.split(' ').length - 1) == 1) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    checkIfStringIsDate(string) {
      try {
        if ((string.split('-').length - 1) == 2 && (string.length === 10)) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    changeRouteTitle(title) {
      // this.routeTitle = title
    },
    updateNavbar(val) {
      if (val === 'static') this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff')
      this.navbarType = val
      this.$store.commit('UPDATE_NAVBAR_TYPE', val)

    },
    updateNavbarColor(val) {
      this.navbarColor = val
      this.$store.commit('UPDATE_NAVBAR_COLOR', val)
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter(val) {
      this.footerType = val
      this.$store.commit('UPDATE_FOOTER_TYPE', val)
    },
    updateRouterTransition(val) {
      this.routerTransition = val
      this.$store.commit('UPDATE_ROUTER_TRANSITION', val)
    },
    setNavMenuVisibility(layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val
      this.$store.commit('UPDATE_SCROLL_TO_TOP', val)
    }
  },
  async created() {

    if (this.$route.name === 'dashboard') {
      await this.getDashboardParameters()
    }

    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)

    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch('$store.state.windowWidth', (val) => {
      if (val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch('$store.state.verticalNavMenuWidth', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })
  },
  beforeDestroy() {
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })
  }
}

</script>
<style scoped>
.vs__dropdown-menu {
  z-index: 10030 !important;
}

.con-vs-popup>>>.vs-popup {
  width: 700px !important;
  height: auto !important;
}

.con-vs-popup>>>.vs-popup--content {
  width: 700px !important;
  height: auto !important;
}
</style>
